var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.value ? 'text-info' : 'text-danger'},[_c('i',{class:`fa fa-fw fa-${_vm.value ? 'check' : 'times'}`}),_vm._v(" "+_vm._s(_vm.value ? 'Yes' : 'No')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }